// extracted by mini-css-extract-plugin
export default {"form":"FormPriceBook_form__8whDs","formBody":"FormPriceBook_formBody__5HCpH"};